module.exports = __webpack_public_path__ + "static/media/money-icon.a17f2895.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/money-icon.svg
// module id = 3257
// module chunks = 0